export const FAQ_INCIDENT = {
  title: "SỰ CỐ VÀ KHIẾU NẠI",
  subItems: [
    {
      id: 'bank-linking-issues',
      title: "Sự cố khi liên kết tài khoản ngân hàng",
      contentItems: [
        {
          id: 'cau-1',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng SCB",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Thông tin không chính xác hoặc không nhớ thông tin</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng SCB để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-2',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng Sacombank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Không nhận được mã xác thực OTP khi liên kết</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại số điện thoại bạn đã đăng ký mở tài khoản Sacombank vì mã xác thực OTP sẽ được gửi vào chính số điện thoại đó.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Lỗi "Thông tin thẻ không chính xác"</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng Sacombank 1900 5555 88 để kiểm tra lại thông tin chính xác và thực hiện lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 3: Gửi tin nhắn kích hoạt dịch vụ E-com nhưng tin nhắn báo lỗi "Số thẻ bị trùng"</p>
              <p className="text-gray-700">Hướng dẫn: Sử dụng số điện thoại bạn đã dùng để đăng ký mở tài khoản tại ngân hàng Sacombank để gửi tin nhắn và thử lại.</p>
            </div>
          )
        },
        {
          id: 'cau-3',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng Shinhan Bank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Thông tin không chính xác hoặc không nhớ thông tin</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng Shinhan Bank để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-4',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng Vietinbank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Lỗi thông tin không trùng khớp</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra và nhập chính xác lại các thông tin in trên thẻ và số Ví phải là số điện thoại đăng ký nhận OTP của Vietinbank.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Số thẻ bạn dùng là thẻ cũ có đầu số là 6201</p>
              <p className="text-gray-700">Hướng dẫn: Đến quầy Vietinbank để làm thủ tục cấp lại thẻ mới có đầu số 9704 15 để sử dụng</p>
              <p className="text-gray-700 mt-2">Vấn đề 3: Số điện thoại đăng ký nhận OTP tại ngân hàng Vietinbank đã không còn sử dụng</p>
              <p className="text-gray-700">Hướng dẫn: Đến quầy Vietinbank để làm thủ tục đổi số điện thoại nhận OTP cho tài khoản của bạn và thử liên kết lại.</p>
            </div>
          )
        },
        {
          id: 'cau-5',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng OCB",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản OCB</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng OCB để kiểm tra lại thông tin tài khoản internet banking và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-6',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng Eximbank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản Eximbank</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng Eximbank để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-7',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng ACB",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản ACB</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng ACB để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-8',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng Vietcombank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản VCB</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng VCB để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 3: Lỗi "Không tìm thấy số tài khoản mặc định để sử dụng dịch vụ này"</p>
              <p className="text-gray-700">Hướng dẫn: Đăng nhập trang Internet Banking {'->'} chọn "Cài đặt phương thức nhận OTP" {'->'} Chọn phương thức "SMS" {'->'} Chọn số điện thoại là số Ví GooPay của bạn {'->'} Nhập mã kiểm tra và xác nhận để hoàn tất {'->'} Thử lại</p>
            </div>
          )
        },
        {
          id: 'cau-9',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng VIB",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Thông tin không chính xác hoặc không nhớ thông tin</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng VIB để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-10',
          title: "Vì sao tôi liên kết tài khoản ngân hàng không thành công?",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp trên có thể do một trong các nguyên nhân:</p>
              <p className="text-gray-700">Bạn không nhập đúng số tài khoản hoặc số thẻ ngân hàng.</p>
              <p className="text-gray-700">Tài khoản ngân hàng của bạn chưa đăng ký Internet Banking hoặc SMS Banking (và dịch vụ E-commerce đối với Sacombank, Agribank).</p>
              <p className="text-gray-700">Tài khoản GooPay của bạn đang liên kết với 1 tài khoản ngân hàng khác, hoặc tài khoản ngân hàng của bạn đang liên kết với một tài khoản GooPay khác.</p>
              <p className="text-gray-700">Số điện thoại đăng kí GooPay của bạn không trùng với số điện thoại SMS Banking đăng kí với ngân hàng, và/hoặc chi tiết tên, CMND của bạn không trùng với thông tin đã lưu ở ngân hàng.</p>
              <p className="text-gray-700 mt-2">Bạn cũng có thể tìm hiểu thêm về quy định và cách liên kết với từng ngân hàng /huong-dan/lien-ket-ngan-hang-ctgr67</p>
              <p className="text-gray-700 mt-2">Nếu cần hỗ trợ thêm, vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Liên kết ngân hàng không thành công</p>
              <p className="text-gray-700">- Tên ngân hàng liên kết</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-11',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng BIDV",
          content: (
            <div>
              <p className="font-bold text-gray-700">Vấn đề 1: Báo lỗi "Tên khách hàng không đúng"</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline BIDV 1900 9247 để hỏi lại chính xác thông tin HỌ VÀ TÊN đang được lưu trong hệ thống BIDV và thực hiện liên kết lại bằng thông tin trùng khớp.</p>
              <p className="font-bold text-gray-700 mt-2">Vấn đề 2: Không nhận được mã xác thực OTP để liên kết</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra tin nhắn của số điện thoại bạn đã dùng để đăng ký nhận OTP tại BIDV.</p>
              <p className="font-bold text-gray-700 mt-2">Vấn đề 3: Khách hàng chưa hoàn tất xác nhận Đồng ý xử lý dữ liệu cá nhân tại BIDV</p>
              <p className="text-gray-700">Hướng dẫn: Để không bị gián đoạn giao dịch, vui lòng hoàn tất xác nhận bằng một trong các hình thức sau:</p>
              <p className="text-gray-700">- Đăng nhập và thực hiện trên ứng dụng BIDV SmartBanking.</p>
              <p className="text-gray-700">- Đến trực tiếp các Chi nhánh/Phòng giao dịch BIDV trên toàn quốc.</p>
              <p className="text-gray-700">- Liên hệ Tổng đài Chăm sóc khách hàng 24/7: 1900 9247.</p>
            </div>
          )
        },
        {
          id: 'cau-12',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng VPBank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản VPBank</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng VPBank để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        },
        {
          id: 'cau-13',
          title: "Các vấn đề thường gặp khi liên kết tài khoản ngân hàng TPBank",
          content: (
            <div>
              <p className="text-gray-700">Vấn đề 1: Trang web liên kết ngân hàng không hiển thị hoặc hiển thị trang trắng</p>
              <p className="text-gray-700">Hướng dẫn: Kiểm tra lại chất lượng kết nối mạng và thử lại.</p>
              <p className="text-gray-700 mt-2">Vấn đề 2: Không thể đăng nhập tài khoản TPBank</p>
              <p className="text-gray-700">Hướng dẫn: Liên hệ hotline ngân hàng TPBank để kiểm tra lại thông tin tài khoản và thực hiện đăng nhập lại.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'deposit-withdrawal-issues',
      title: "Sự cố khi nạp tiền hoặc rút tiền",
      contentItems: [
        {
          id: 'cau-14',
          title: "Tôi có thể hủy giao dịch đang chờ xử lý hoặc thực hiện lại giao dịch được không?",
          content: (
            <div>
              <p className="text-gray-700">Bạn vui lòng đợi kết quả xử lý giao dịch từ GooPay và không cần thực hiện lại giao dịch để tránh thanh toán lặp 2 lần. Bạn cũng không thể hủy giao dịch đang trong quá trình xử lý.</p>
            </div>
          )
        },
        {
          id: 'cau-15',
          title: "Vì sao tôi nạp tiền từ tài khoản ngân hàng vào GooPay không thành công?",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp trên có thể do một trong các nguyên nhân:</p>
              <p className="text-gray-700">Tài khoản ngân hàng không hoạt động/ bị đóng băng. Vui lòng liên hệ với bộ phận CSKH của ngân hàng của bạn để kiểm tra.</p>
              <p className="text-gray-700">Số dư trong tài khoản ngân hàng của bạn đang thấp hơn giá trị nạp tiền cộng số dư tối thiểu do ngân hàng quy định. Trong trường hợp này, bạn cần nạp thêm tiền vào tài khoản ngân hàng rồi thực hiện lại giao dịch.</p>
              <p className="text-gray-700">Tài khoản GooPay của bạn vượt hạn mức nạp tiền trong ngày khi thực hiện giao dịch. Tìm hiểu thêm về hạn mức giao dịch mỗi ngày: /hoi-dap/han-muc-giao-dich-moi-ngay</p>
              <p className="text-gray-700 mt-2">Nếu bạn không gặp phải những vấn đề trên, vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Nạp tiền từ TK ngân hàng thất bại</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-16',
          title: "Rút tiền về ngân hàng: tài khoản GooPay bị trừ tiền nhưng tài khoản ngân hàng không thay đổi",
          content: (
            <div>
              <p className="text-gray-700">Xin bạn hoàn toàn yên tâm là GooPay và ngân hàng luôn tự động kiểm tra và đối soát để đảm bảo số dư của bạn được cập nhật chính xác. Với trường hợp này, tiền sẽ được hoàn lại vào tài khoản GooPay hoặc tài khoản ngân hàng của bạn trong vòng 48 giờ.</p>
              <p className="text-gray-700 mt-2">Trường hợp sau 48 giờ bạn vẫn không được hoàn tiền, vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: TK GooPay trừ tiền nhưng TK ngân hàng không đổi</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-17',
          title: "Tài khoản bị trừ tiền nhưng giao dịch đang chờ xử lý",
          content: (
            <div>
              <p className="text-gray-700">Các trường hợp giao dịch nạp/rút tiền có tình trạng "đang chờ xử lý" xảy ra do dữ liệu giữa GooPay và ngân hàng chưa đồng bộ kịp thời.</p>
              <p className="text-gray-700 mt-2">Khi gặp trường hợp này, bạn vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Giao dịch chờ xử lý</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
              <p className="text-gray-700 mt-2">CSKH sẽ hỗ trợ kiểm tra chính xác tình trạng giao dịch và phản hồi với bạn.</p>
              <p className="text-gray-700 mt-2">Bạn có thể hoàn toàn yên tâm là GooPay và ngân hàng/đối tác luôn kiểm tra và đối soát để đảm bảo số dư của bạn được cập nhật chính xác. Trong trường hợp giao dịch thất bại, tiền sẽ được hoàn lại vào tài khoản GooPay của bạn trong vòng 48 giờ không tính thứ 7, Chủ Nhật và ngày Lễ.</p>
            </div>
          )
        },
        {
          id: 'cau-18',
          title: "Nạp tiền từ ngân hàng: tài khoản ngân hàng bị trừ tiền 2 lần",
          content: (
            <div>
              <p className="text-gray-700">Rất có thể bạn đã vô tình thực hiện lặp giao dịch 2 lần. Vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: TK ngân hàng bị trừ tiền 2 lần</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-19',
          title: "Vì sao tôi rút tiền từ GooPay về tài khoản ngân hàng không thành công?",
          content: (
            <div>
              <p className="text-gray-700">Trường hợp trên có thể do một trong các nguyên nhân:</p>
              <p className="text-gray-700">1. Tài khoản ngân hàng không hoạt động/ bị đóng băng. Vui lòng liên hệ với bộ phận CSKH của ngân hàng của bạn để kiểm tra.</p>
              <p className="text-gray-700">2. Tài khoản GooPay của bạn vượt hạn mức rút tiền trong ngày khi thực hiện giao dịch. Tìm hiểu thêm về hạn mức rút tiền /?questionId=41&name=tại_đây.</p>
              <p className="text-gray-700 mt-2">Nếu bạn không gặp phải những vấn đề trên, vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Rút tiền về TK ngân hàng thất bại</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-20',
          title: "Nạp tiền từ ngân hàng: Tài khoản ngân hàng bị trừ tiền nhưng tài khoản GooPay không thay đổi",
          content: (
            <div>
              <p className="text-gray-700">Có thể hệ thống chưa kịp cập nhật số dư trong tài khoản GooPay. Bạn hãy đăng xuất tài khoản GooPay và đăng nhập lại để kiểm tra lại số dư.</p>
              <p className="text-gray-700 mt-2">Nếu vẫn chưa thấy số dư thay đổi, xin bạn hoàn toàn yên tâm là GooPay và ngân hàng luôn tự động kiểm tra và đối soát để đảm bảo số dư của bạn được cập nhật chính xác. Tiền sẽ được hoàn lại vào tài khoản GooPay hoặc tài khoản ngân hàng của bạn trong vòng 48 giờ.</p>
              <p className="text-gray-700 mt-2">Trường hợp sau 48 giờ bạn vẫn không được hoàn tiền, vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: TK ngân hàng trừ tiền nhưng TK GooPay không đổi</p>
              <p className="text-gray-700">- Mã giao dịch (Mã TID)</p>
              <p className="text-gray-700">- Tên ngân hàng thực hiện giao dịch</p>
              <p className="text-gray-700">- Tên chủ thẻ/chủ tài khoản ngân hàng</p>
            </div>
          )
        },
        {
          id: 'cau-21',
          title: "Tôi có thể chuyển tiền cho người chưa có tài khoản Ví GooPay được không?",
          content: (
            <div>
              <p className="text-gray-700">Được. Lúc này, người được nhận tiền sẽ nhận được thông báo qua tin nhắn EMS kèm đường dẫn tải ứng dụng Ví GooPay. Trong vòng 48 giờ, người nhận chỉ cần tải và đăng ký tài khoản Ví GooPay để nhận tiền.</p>
              <p className="text-gray-700 mt-2">Trường hợp người được nhận tiền chưa kịp đăng ký tài khoản, số tiền đã chuyển sẽ tự động được hoàn trả vào tài khoản của người gửi.</p>
            </div>
          )
        }
      ]
    },
    {
      id: 'promotion-issues',
      title: "Sự cố khi tham gia khuyến mãi",
      contentItems: [
        {
          id: 'cau-22',
          title: "Tôi không sử dụng được thẻ quà tặng",
          content: (
            <div>
              <p className="text-gray-700">Mỗi thẻ quà tặng có điều kiện sử dụng, dịch vụ áp dụng và thời hạn sử dụng nhất định. Bạn vui lòng kiểm tra lại chi tiết thẻ quà tặng để chắc chắn bạn đã sử dụng thẻ quà tặng đúng cách. Xem hướng dẫn sử dụng thẻ quà tặng /?questionId=114&name=tại_đây.</p>
              <p className="text-gray-700 mt-2">Nếu vẫn có thắc mắc, bạn vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Không sử dụng được thẻ quà tặng</p>
              <p className="text-gray-700">- Tên CTKM</p>
              <p className="text-gray-700">- Dịch vụ dùng quà tặng</p>
              <p className="text-gray-700">- Thời gian thực hiện</p>
              <p className="text-gray-700">- Câu thông báo trên ứng dụng (đính kèm hình nếu có)</p>
            </div>
          )
        },
        {
          id: 'cau-23',
          title: "Tôi nhận được thông báo mã khuyến mãi không hợp lệ",
          content: (
            <div>
              <p className="text-gray-700">Các chương trình khuyến mãi (CTKM) thường có những điều kiện tham gia như:</p>
              <p className="text-gray-700">- Nhận thưởng 1 lần duy nhất: Mỗi khách hàng tương ứng với 1 CMND, 1 tài khoản GooPay, 1 tài khoản/ thẻ ngân hàng chỉ được nhận thưởng 1 lần trong chương trình. Ví dụ, nếu bạn sử dụng cùng 1 tài khoản ngân hàng cho 2 tài khoản GooPay khác nhau thì bạn cũng chỉ được nhận thưởng 1 lần.</p>
              <p className="text-gray-700">- Các CTKM không áp dụng đồng thời: Mỗi khách hàng khi đã nhận thưởng của 1 CTKM nào đó sẽ không được tham gia một vài CTKM khác.</p>
              <p className="text-gray-700 mt-2">Bạn vui lòng kiểm tra lại thể lệ các CTKM /tin-tuc/khuyen-mai&name=tại_đây. Nếu bạn vẫn có thắc mắc, bạn vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Mã khuyến mãi không hợp lệ</p>
              <p className="text-gray-700">- Tên CTKM</p>
              <p className="text-gray-700">- Thời gian nhập mã</p>
              <p className="text-gray-700">- Câu thông báo trên ứng dụng (đính kèm hình nếu có)</p>
            </div>
          )
        },
        {
          id: 'cau-24',
          title: "Tôi không nhận được quà tặng dù đã làm theo hướng dẫn",
          content: (
            <div>
              <p className="text-gray-700">Các chương trình khuyến mãi (CTKM) thường có các "nhiệm vụ" và bạn phải thực hiện đầy đủ theo yêu cầu để được nhận thưởng. Ví dụ: Khi tham gia CTKM Liên kết tài khoản, bạn có thể sẽ quên bước nạp tiền sau khi liên kết tài khoản thành công.</p>
              <p className="text-gray-700 mt-2">Bạn vui lòng kiểm tra lại thể lệ các CTKM /tin-tuc/khuyen-mai&name=tại_đây. Nếu vẫn có thắc mắc, bạn vui lòng để lại lời nhắn bên dưới cho bộ phận CSKH và cung cấp các thông tin sau:</p>
              <p className="text-gray-700">- Nội dung: Không nhận được quà CTKM</p>
              <p className="text-gray-700">- Tên CTKM</p>
              <p className="text-gray-700">- Thời gian tham gia</p>
            </div>
          )
        }
      ]
    }
  ]
};
